import { combineReducers } from 'redux'
import Builder from '../builder/redux/builder.reducer'

const LessonReducer = combineReducers({
  Builder
})

export default LessonReducer
